import { useQuery } from "react-query";
import { AuditLogService } from "./auditLog.service";

// GET List
const useGetList = (page: number, option?: Object, enabled?: boolean) => {
  return useQuery(
    ["listAuditLog", page, option],
    async () => {
      const { data } = await AuditLogService.getList({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true, enabled: enabled },
  );
};

const useGetListAuditLogByType = (
  params: TParams & { type?: string; action?: string; id?: string },
) =>
  useQuery({
    queryKey: ["get_list_audit_log_by_type", params],
    queryFn: async () => {
      const { data } = await AuditLogService.getListByType(params);
      return data;
    },
    enabled: Boolean(params.type) && Boolean(params.action),
  });

export { useGetList, useGetListAuditLogByType };
